// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blog-page-olhR6 {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Blog-wrap-rOwrT {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.Blog-sec-R05vI {
  padding: 56px 0;
}

.Blog-alt-BIciv {
  background: #f7f8f9;
}

.Blog-h2-Sy9Mi {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.Blog-h2Left-uIDrT {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

/* Coming-soon banner */

.Blog-soonSec-tOE1q {
  padding: 36px 0 8px;
  text-align: center;
}

.Blog-soonBadge-tgQRE {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  background: #fff0ef;
  color: var(--red);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid #f6c9cb;
}

.Blog-soonDot-QXnoj {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--red);
}

.Blog-soonText-kJIQS {
  max-width: 640px;
  margin: 18px auto 0;
  font-size: 16px;
  line-height: 1.6;
  color: var(--muted);
}

.Blog-inlineLink-GG1Lh {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.Blog-inlineLink-GG1Lh:hover {
  text-decoration: underline;
}

/* Topic cards */

.Blog-grid-hcQYr {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.Blog-card-RivbC {
  position: relative;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  background: #fff;
}

.Blog-cardIc-hM86h {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  margin-bottom: 14px;
}

.Blog-cardIc-hM86h svg {
  width: 26px;
  height: 26px;
}

.Blog-cardTag-rYR01 {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--green-d);
  margin-bottom: 6px;
}

.Blog-cardTitle-Gfbc_ {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 8px;
  line-height: 1.3;
}

.Blog-cardText-yE_Cq {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0 0 16px;
}

.Blog-cardSoon-kgDTe {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  color: var(--muted);
  background: #f0f2f4;
  border: 1px solid var(--line);
  padding: 4px 12px;
  border-radius: 999px;
}

/* Notify */

.Blog-notifyCard-fJWb8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 28px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 32px 34px;
  background: #e4f6f3;
}

.Blog-notifyText-dsLUR {
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
  max-width: 540px;
}

.Blog-notifyActions-pMjnN {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.Blog-notifyBtn-CspvP {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.Blog-notifyBtn-CspvP:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.Blog-notifyBtnAlt-P_LQf {
  color: var(--ink);
  font-weight: 700;
  text-decoration: none;
  font-size: 14px;
}

.Blog-notifyBtnAlt-P_LQf:hover {
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .Blog-grid-hcQYr {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 680px) {
  .Blog-sec-R05vI {
    padding: 44px 0;
  }
  .Blog-grid-hcQYr {
    grid-template-columns: 1fr;
  }
  .Blog-notifyCard-fJWb8 {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
  .Blog-notifyActions-pMjnN {
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
}

@media (prefers-color-scheme: dark) {
  .Blog-page-olhR6 {
    background: #14171a;
    color: #f3f4f6;
  }
  .Blog-alt-BIciv {
    background: #1a1e22;
  }
  .Blog-h2-Sy9Mi,
  .Blog-h2Left-uIDrT,
  .Blog-cardTitle-Gfbc_,
  .Blog-notifyBtnAlt-P_LQf {
    color: #f3f4f6;
  }
  .Blog-soonText-kJIQS,
  .Blog-cardText-yE_Cq,
  .Blog-notifyText-dsLUR {
    color: #9aa3ad;
  }
  .Blog-card-RivbC {
    background: #1d2125;
    border-color: #2c3137;
  }
  .Blog-cardIc-hM86h,
  .Blog-soonBadge-tgQRE {
    background: rgba(232, 35, 43, 0.14);
    border-color: rgba(232, 35, 43, 0.3);
  }
  .Blog-cardSoon-kgDTe {
    background: #14171a;
    border-color: #2c3137;
    color: #9aa3ad;
  }
  .Blog-notifyCard-fJWb8 {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/blog/Blog.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;;AACvB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,WAAW;;AACX;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;EACA;IACE,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;IAGE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;;IAEE,mCAAmC;IACnC,oCAAoC;EACtC;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n.h2Left {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n\n/* Coming-soon banner */\n.soonSec {\n  padding: 36px 0 8px;\n  text-align: center;\n}\n.soonBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff0ef;\n  color: var(--red);\n  font-weight: 800;\n  font-size: 13px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid #f6c9cb;\n}\n.soonDot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--red);\n}\n.soonText {\n  max-width: 640px;\n  margin: 18px auto 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--muted);\n}\n.inlineLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.inlineLink:hover {\n  text-decoration: underline;\n}\n\n/* Topic cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n.card {\n  position: relative;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  background: #fff;\n}\n.cardIc {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.cardIc svg {\n  width: 26px;\n  height: 26px;\n}\n.cardTag {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--green-d);\n  margin-bottom: 6px;\n}\n.cardTitle {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  line-height: 1.3;\n}\n.cardText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0 0 16px;\n}\n.cardSoon {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--muted);\n  background: #f0f2f4;\n  border: 1px solid var(--line);\n  padding: 4px 12px;\n  border-radius: 999px;\n}\n\n/* Notify */\n.notifyCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  flex-wrap: wrap;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 32px 34px;\n  background: #e4f6f3;\n}\n.notifyText {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0;\n  max-width: 540px;\n}\n.notifyActions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n.notifyBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.16s, transform 0.16s;\n}\n.notifyBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n.notifyBtnAlt {\n  color: var(--ink);\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 14px;\n}\n.notifyBtnAlt:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 1000px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .grid {\n    grid-template-columns: 1fr;\n  }\n  .notifyCard {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .notifyActions {\n    align-items: stretch;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .h2Left,\n  .cardTitle,\n  .notifyBtnAlt {\n    color: #f3f4f6;\n  }\n  .soonText,\n  .cardText,\n  .notifyText {\n    color: #9aa3ad;\n  }\n  .card {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .cardIc,\n  .soonBadge {\n    background: rgba(232, 35, 43, 0.14);\n    border-color: rgba(232, 35, 43, 0.3);\n  }\n  .cardSoon {\n    background: #14171a;\n    border-color: #2c3137;\n    color: #9aa3ad;\n  }\n  .notifyCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Blog-page-olhR6`,
	"wrap": `Blog-wrap-rOwrT`,
	"sec": `Blog-sec-R05vI`,
	"alt": `Blog-alt-BIciv`,
	"h2": `Blog-h2-Sy9Mi`,
	"h2Left": `Blog-h2Left-uIDrT`,
	"soonSec": `Blog-soonSec-tOE1q`,
	"soonBadge": `Blog-soonBadge-tgQRE`,
	"soonDot": `Blog-soonDot-QXnoj`,
	"soonText": `Blog-soonText-kJIQS`,
	"inlineLink": `Blog-inlineLink-GG1Lh`,
	"grid": `Blog-grid-hcQYr`,
	"card": `Blog-card-RivbC`,
	"cardIc": `Blog-cardIc-hM86h`,
	"cardTag": `Blog-cardTag-rYR01`,
	"cardTitle": `Blog-cardTitle-Gfbc_`,
	"cardText": `Blog-cardText-yE_Cq`,
	"cardSoon": `Blog-cardSoon-kgDTe`,
	"notifyCard": `Blog-notifyCard-fJWb8`,
	"notifyText": `Blog-notifyText-dsLUR`,
	"notifyActions": `Blog-notifyActions-pMjnN`,
	"notifyBtn": `Blog-notifyBtn-CspvP`,
	"notifyBtnAlt": `Blog-notifyBtnAlt-P_LQf`
};
module.exports = ___CSS_LOADER_EXPORT___;
